import api from './axiosConfig';
import { TIMELINE_ENDPOINT } from './apiEndpoints';
import timelineData from '../data/timelineData'
import { logError } from './errorLogService';

export const fetchTimeline = async () => {

    try {
        const response = await api.get(TIMELINE_ENDPOINT());
        return response?.data?.length > 0 ? response.data : timelineData;

    } catch (error) {
        console.error("Error fetching hero data", error);

        await logError('timeline_data_fetch', error, {
            endpoint: TIMELINE_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        return timelineData;
    }
};
